module.exports = __webpack_public_path__ + "assets/img/o1.141fa611.png";